/**
 * Extension of a JS date object. This method adds 'ndays' to the
 * date and returns a new date object with those days added.
 * @param {integer} ndays - number of days to add.
 * @returns {Date} - new date object with 'ndays' added
 */

export function extendAddDays() {
    Date.prototype.addDays = function (ndays) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + ndays);
        return date;
    };
}

/**
 * Extension of a JS date object. This method adds 'nmonths' to the
 * date and returns a new date object with those months added.
 * @param {integer} nmonths
 * @returns {Date} - new date object with 'nmonths' added.
 */

export function extendAddMonths() {
    Date.prototype.addMonths = function (nmonths) {
        var date = new Date(this.valueOf());
        var m,
            d = (date = new Date(+date)).getUTCDate();
        date.setUTCMonth(date.getUTCMonth() + nmonths, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
        return date;
    };
}

/**
 * Extension of a JS date object. This method adds 'nSemiMonths' to the
 * date and returns a new date object with that amount of semi-months added.
 *
 * @param {integer} nSemiMonths
 */
export function extendAddSemimonths() {
    extendAddMonths();
    Date.prototype.addSemiMonths = function (nSemiMonths) {
        var date = new Date(this.valueOf());
        const sgn = Math.sign(nSemiMonths);
        for (let i = 0; i < Math.abs(nSemiMonths); i++) {
            if (sgn > 0) {
                if (date.getUTCDate() != 1) {
                    date = date.addMonths(1);
                    date.setUTCDate(1);
                } else {
                    date.setUTCDate(16);
                }
            } else {
                if (date.getUTCDate() != 1) {
                    date.setUTCDate(1);
                } else {
                    date = date.addMonths(-1);
                    date.setUTCDate(16);
                }
            }
        }
        return date;
    };
}
